<template lang="pug">
.change-log-timeline
  v-timeline(dense)
    v-slide-y-reverse-transition(group)
      v-timeline-item(
        v-for="change in changes",
        :key="change.uid",
        class="mb-5",
        color="white",
        small,
      )
        v-card.change-display(elevation="0" color="#F9F9FE")
          h3.primary--text.pb-3 {{ get(change, 'entity') }}
          h5.pb-3 Updated by:&nbsp;
            span.h6.icon--text {{ get(change, 'userName') }}
          h5.pb-3 Updated on:&nbsp;
            span.h6.icon--text {{ `${$formattedDate(get(change, 'date'))} (UTC)`}}
          template(v-for="changeGroup in get(change, 'details')")
            template(v-if="get(changeGroup, 'label') != 'Content'")
              h5.pb-3(v-if="get(changeGroup, 'label') != 'root'") {{ get(changeGroup, 'label') }}
              template(v-for="change in get(changeGroup, 'changes', [])")
                v-row.change-row
                  v-col
                    h5 {{ get(change, 'label') }}
                  v-col
                    h5 From:
                    h6 {{ get(change, 'from') }}
                  v-col
                    h5 To:
                    h6 {{ get(change, 'to') }}
            template(v-else)
              h5.primary--text.pb-3 {{ get(changeGroup, 'label') }}
              template(v-for="change in get(changeGroup, 'changes', [])")
                v-row.change-row
                  v-col
                    h5(style="color: #212166;") {{ get(change, 'label') }}
                v-row.change-row
                  v-col
                    h5 From:
                  v-col
                    h5 To:
                v-row.change-row
                  v-col
                    h6 {{ get(change, 'from') }}
                  v-col
                    h6 {{ get(change, 'to') }}
      v-timeline-item(
        v-if="loading"
        class="mb-5",
        color="white",
        small,
        key="key-skeleton"
      )
        v-skeleton-loader(
          v-if="loading",
          type="article, actions",
        )
  v-row(justify="center", v-if="showAction")
    v-col(cols="auto")
      g-btn.action-button(
        @click="$emit('action')",
        color="primaryHover",
        dark,
        width="200px",
      )
        h7 Show more
        v-icon.ml-1 mdi-chevron-down
</template>

<style lang="scss" scoped>
.change-log-timeline {
  .v-timeline {
    &::before {
      top: 24px + 10px;
      height: calc(100% - 34px);
    }

    ::v-deep .v-timeline-item:last-child {
      position: relative;
      &::before {
        background-color: white;
        content: "";
        width: 2px;
        position: absolute;
        height: calc(100% - 10px);
        bottom: 0;
        left: calc(48px - 1px);
      }
    }
  }
  ::v-deep .v-timeline-item__dot.v-timeline-item__dot--small {
    position: absolute;
    top: 10px;
    background-color: var(--v-primary-base);
    height: 18px;
    width: 18px;
    left: calc(50% - 9px);

    .v-timeline-item__inner-dot {
      height: 8px;
      width: 8px;
      margin: 5px;
    }
  }
  .action-button {
    border-radius: 0;
  }
  .change-row {
    color: var(--v-text-base);
    .col {
      padding-top: 0;
      display: flex;
      h6 {
        margin-left: 4px;
      }
    }
  }
  .change-display {
    padding: 16px 50px;
    &::before, &::after {
      border-right-color: #F9F9FE;
      top: 10px;
    }
  }
}
</style>

<script>
import { get, find } from 'lodash';
export default {
  props: {
    showAction: {
      type: Boolean,
      default: true,
    },
    changes: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  methods: {
    get,
  },
}
</script>
